import { Add20Filled, Add20Regular, AppsAddIn20Filled, AppsAddIn20Regular, ArrowDownload20Filled, ArrowDownload20Regular, ArrowHookUpLeft20Filled, ArrowHookUpLeft20Regular, ArrowMove20Filled, ArrowMove20Regular, ArrowUpload20Filled, ArrowUpload20Regular, bundleIcon, CalendarEmpty20Filled, CalendarEmpty20Regular, Checkmark20Filled, Checkmark20Regular, CheckmarkCircle20Filled, CheckmarkCircle20Regular, ChevronLeft20Filled, ChevronLeft20Regular, ChevronRight20Filled, ChevronRight20Regular, Copy20Filled, Copy20Regular, Delete20Filled, Delete20Regular, Dismiss20Filled, Dismiss20Regular, Document20Filled, Document20Regular, DocumentPdf20Filled, DocumentPdf20Regular, Edit20Filled, Edit20Regular, EyeOff20Filled, EyeOff20Regular, Folder20Filled, Folder20Regular, FolderArrowRight20Filled, FolderArrowRight20Regular, Link20Filled, Link20Regular, Mail20Filled, Mail20Regular, MoreHorizontal20Filled, MoreHorizontal20Regular, Open20Filled, Open20Regular, People20Filled, People20Regular, Pin20Filled, Pin20Regular, PinOff20Filled, PinOff20Regular, Save20Filled, Save20Regular, Search20Filled, Search20Regular, Share20Filled, Share20Regular, Star20Filled, Star20Regular, StarOff20Filled, StarOff20Regular, 
// $TODO: Swap back to size 20 when icons are fixed
Subtract24Filled, Subtract24Regular, Warning20Filled, Warning20Regular, } from '@fluentui/react-icons';
import React from 'react';
import { useActionMenuIconsStyles } from './ActionContextMenuIcons.styles';
var DualStateIcon = function (_a) {
    var filledIcon = _a.filledIcon, regularIcon = _a.regularIcon, fluentIconProps = _a.fluentIconProps;
    var styles = useActionMenuIconsStyles();
    var Icon = bundleIcon(filledIcon, regularIcon);
    return (React.createElement("span", { className: "".concat(fluentIconProps.className, " ").concat(fluentIconProps.filled ? styles.filledIcon : styles.regularIcon) },
        React.createElement(Icon, { filled: fluentIconProps.filled, primaryFill: fluentIconProps.primaryFill, title: fluentIconProps.title })));
};
var CreateDualStateIcon = function (filledIcon, regularIcon, props) { return (React.createElement(DualStateIcon, { filledIcon: filledIcon, regularIcon: regularIcon, fluentIconProps: props })); };
var AddIcon = function (props) {
    return CreateDualStateIcon(Add20Filled, Add20Regular, props);
};
var AppsAddInIcon = function (props) {
    return CreateDualStateIcon(AppsAddIn20Filled, AppsAddIn20Regular, props);
};
var CalendarIcon = function (props) {
    return CreateDualStateIcon(CalendarEmpty20Filled, CalendarEmpty20Regular, props);
};
var CheckmarkCircleIcon = function (props) {
    return CreateDualStateIcon(CheckmarkCircle20Filled, CheckmarkCircle20Regular, props);
};
var CheckmarkIcon = function (props) {
    return CreateDualStateIcon(Checkmark20Filled, Checkmark20Regular, props);
};
var ChevronLeftIcon = function (props) {
    return CreateDualStateIcon(ChevronLeft20Filled, ChevronLeft20Regular, props);
};
var ChevronRightIcon = function (props) {
    return CreateDualStateIcon(ChevronRight20Filled, ChevronRight20Regular, props);
};
var CopyIcon = function (props) {
    return CreateDualStateIcon(Copy20Filled, Copy20Regular, props);
};
var DeleteIcon = function (props) {
    return CreateDualStateIcon(Delete20Filled, Delete20Regular, props);
};
var DismissIcon = function (props) {
    return CreateDualStateIcon(Dismiss20Filled, Dismiss20Regular, props);
};
var DocumentIcon = function (props) {
    return CreateDualStateIcon(Document20Filled, Document20Regular, props);
};
var DocumentPdfIcon = function (props) {
    return CreateDualStateIcon(DocumentPdf20Filled, DocumentPdf20Regular, props);
};
var DownloadIcon = function (props) {
    return CreateDualStateIcon(ArrowDownload20Filled, ArrowDownload20Regular, props);
};
var EditIcon = function (props) {
    return CreateDualStateIcon(Edit20Filled, Edit20Regular, props);
};
var FolderIcon = function (props) {
    return CreateDualStateIcon(Folder20Filled, Folder20Regular, props);
};
var HideIcon = function (props) {
    return CreateDualStateIcon(EyeOff20Filled, EyeOff20Regular, props);
};
var LinkIcon = function (props) {
    return CreateDualStateIcon(Link20Filled, Link20Regular, props);
};
var MailIcon = function (props) {
    return CreateDualStateIcon(Mail20Filled, Mail20Regular, props);
};
var MoreIcon = function (props) {
    return CreateDualStateIcon(MoreHorizontal20Filled, MoreHorizontal20Regular, props);
};
var MoveFolderIcon = function (props) {
    return CreateDualStateIcon(FolderArrowRight20Filled, FolderArrowRight20Regular, props);
};
var MoveIcon = function (props) {
    return CreateDualStateIcon(ArrowMove20Filled, ArrowMove20Regular, props);
};
var OpenIcon = function (props) {
    return CreateDualStateIcon(Open20Filled, Open20Regular, props);
};
var PeopleIcon = function (props) {
    return CreateDualStateIcon(People20Filled, People20Regular, props);
};
var PinIcon = function (props) {
    return CreateDualStateIcon(Pin20Filled, Pin20Regular, props);
};
var RestoreIcon = function (props) {
    return CreateDualStateIcon(ArrowHookUpLeft20Filled, ArrowHookUpLeft20Regular, props);
};
var SaveIcon = function (props) {
    return CreateDualStateIcon(Save20Filled, Save20Regular, props);
};
var SearchIcon = function (props) {
    return CreateDualStateIcon(Search20Filled, Search20Regular, props);
};
var ShareIcon = function (props) {
    return CreateDualStateIcon(Share20Filled, Share20Regular, props);
};
var StarIcon = function (props) {
    return CreateDualStateIcon(Star20Filled, Star20Regular, props);
};
var StarOffIcon = function (props) {
    return CreateDualStateIcon(StarOff20Filled, StarOff20Regular, props);
};
var SubtractIcon = function (props) {
    return CreateDualStateIcon(Subtract24Filled, Subtract24Regular, props);
};
var UnpinIcon = function (props) {
    return CreateDualStateIcon(PinOff20Filled, PinOff20Regular, props);
};
var UploadIcon = function (props) {
    return CreateDualStateIcon(ArrowUpload20Filled, ArrowUpload20Regular, props);
};
var WarningIcon = function (props) {
    return CreateDualStateIcon(Warning20Filled, Warning20Regular, props);
};
export var ActionContextMenuIcons = {
    AddIcon: AddIcon,
    AppsAddInIcon: AppsAddInIcon,
    CalendarIcon: CalendarIcon,
    CheckmarkCircleIcon: CheckmarkCircleIcon,
    CheckmarkIcon: CheckmarkIcon,
    ChevronLeftIcon: ChevronLeftIcon,
    ChevronRightIcon: ChevronRightIcon,
    CopyIcon: CopyIcon,
    DeleteIcon: DeleteIcon,
    DismissIcon: DismissIcon,
    DocumentIcon: DocumentIcon,
    DocumentPdfIcon: DocumentPdfIcon,
    DownloadIcon: DownloadIcon,
    EditIcon: EditIcon,
    FolderIcon: FolderIcon,
    HideIcon: HideIcon,
    LinkIcon: LinkIcon,
    MailIcon: MailIcon,
    MoreIcon: MoreIcon,
    MoveFolderIcon: MoveFolderIcon,
    MoveIcon: MoveIcon,
    OpenIcon: OpenIcon,
    PeopleIcon: PeopleIcon,
    PinIcon: PinIcon,
    RestoreIcon: RestoreIcon,
    SaveIcon: SaveIcon,
    SearchIcon: SearchIcon,
    ShareIcon: ShareIcon,
    StarIcon: StarIcon,
    StarOffIcon: StarOffIcon,
    SubtractIcon: SubtractIcon,
    UnpinIcon: UnpinIcon,
    UploadIcon: UploadIcon,
    WarningIcon: WarningIcon,
};
//# sourceMappingURL=ActionContextMenuIcons.js.map